// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1dgvO","topBottomGutter":"Layout_topBottomGutter__1kYmW"};